<template>
    <div class="hierarchy-container">
        <div class="column">
            <div class="item" v-for="i in tags.filter(t => t.parent === null || t.parent === '' || typeof t.parent === 'undefined')" :key="i._id">
                <p>{{ i.name }}</p>
                <button type="button" class="green-btn">+</button>
                <button type="button" v-if="tags.filter(t => t.parent === i._id).length > 0" class="green-btn" @click="addElementToHierarchy(i._id, 0)"> > </button>
            </div>
        </div>
        <div class="column" v-for="(h, index) in hierarchy" :key="h">
            <div class="item" v-for="i in tags.filter(t => t.parent === h)" :key="i._id">
                <p>{{ i.name }}</p>
                <button type="button" class="green-btn">+</button>
                <button type="button" v-if="tags.filter(t => t.parent === i._id).length > 0" class="green-btn" @click="addElementToHierarchy(i._id, index + 1)"> > </button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Hierarchy",
        props: {
            tags: Array
        },
        data() {
            return {
                hierarchy: [],
            }
        },
        methods: {
            addElementToHierarchy(id, pos) {
                if (this.hierarchy.length <= pos) this.hierarchy.push(0);
                this.hierarchy[pos] = id;
            }
        }
    }
</script>
<style lang="scss">
    .hierarchy-container {
        display: flex;
        border: 1px solid #5b7571;

        .column {
            width: 250px;
            border-right: 1px solid #5b7571;
            max-height: 500px;
            overflow: scroll;
        }
        .item {
            display: flex;
            align-items: center;

            p {
                flex: 1;
                font-size: 14px;
            }
            .green-btn {
                border-radius: 50%;
                padding: 0;
                height: 30px;
                width: 30px;
                margin: 0 2px 0 0;
            }
            &:not(:last-child), &:first-child {
                border-bottom: 1px solid #5b7571;
            }
        }
    }
</style>